import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import './UsersList.css';

class UsersList extends Component {
	render() {
		let sortedUsers = this.props.users.sort((a, b) => {
			let sortBy = user => user.displayName.toLowerCase() || 0;
			if (sortBy(a) < sortBy(b)) return 1;
    		if (sortBy(a) > sortBy(b)) return -1;
			return 0;
		});

        return <ul id="members">
            {sortedUsers.reverse().map(user =>
        		<li key={user.uid}>
        			<Link to={`/u/${user.uid}`}>{user.displayName}</Link>
        		</li>
        	)}
        </ul>;
	}
}

export default UsersList;



// WEBPACK FOOTER //
// ./src/UsersList.js